import type { OrbitalBridgeQuestionResult } from '../../../../shared/results';
import type { BridgeMode } from '../../../../shared/drafts';
import type { BridgePhase } from '../domain/bridgeRules';

export type BridgeGameState = {
  phase: BridgePhase;
  mode: BridgeMode;
  questionIndex: number;
  score: number;
  lives: number;
  streak: number;
  correct: number;
  wrong: number;
  attempts: number;
  segment: number;
  roverX: number;
  cameraX: number;
  remainingMs: number | null;
  questionResults: OrbitalBridgeQuestionResult[];
};

export function createBridgeGameState(mode: BridgeMode, timeLimitSeconds: number | null): BridgeGameState {
  return {
    phase: 'intro',
    mode,
    questionIndex: 0,
    score: 0,
    lives: 3,
    streak: 0,
    correct: 0,
    wrong: 0,
    attempts: 0,
    segment: 0,
    roverX: 210,
    cameraX: 640,
    remainingMs: timeLimitSeconds == null ? null : timeLimitSeconds * 1000,
    questionResults: [],
  };
}
